import React from "react";
import Activity from "./Activity";

function ComingSoon() {
  return (
    <>
    <Activity/>
    <div className="flex items-center justify-center min-h-screen ">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold  text-center">
        Page coming soon
      </h1>
    </div>
    </>
  );
}

export default ComingSoon;
